/**
 * Recently Viewed Products Tracker
 * Tracks product views in localStorage for display in recently-viewed-products section
 */

const STORAGE_KEY = 'theme:recently-viewed-products';
const MAX_PRODUCTS = 12;

class RecentlyViewedTracker {
  constructor() {
    this.productHandle = this.getCurrentProductHandle();

    if (this.productHandle) {
      this.addProduct(this.productHandle);
    }
  }

  /**
   * Get the current product handle from the page
   */
  getCurrentProductHandle() {
    // Try to get from meta tag (most reliable)
    const metaTag = document.querySelector('meta[property="og:url"]');
    if (metaTag) {
      const url = metaTag.getAttribute('content');
      const match = url.match(/\/products\/([^/?]+)/);
      if (match) {
        return match[1];
      }
    }

    // Fallback: try to get from window.location
    const pathname = window.location.pathname;
    const match = pathname.match(/\/products\/([^/?]+)/);
    if (match) {
      return match[1];
    }

    // Fallback: try Shopify.handle if available
    if (window.Shopify && window.Shopify.handle) {
      return window.Shopify.handle;
    }

    return null;
  }

  /**
   * Get the list of recently viewed product handles from localStorage
   */
  getRecentlyViewed() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        return [];
      }

      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error('Error reading recently viewed products:', error);
      return [];
    }
  }

  /**
   * Add a product handle to the recently viewed list
   */
  addProduct(handle) {
    if (!handle) {
      return;
    }

    try {
      let recentlyViewed = this.getRecentlyViewed();

      // Remove the product if it already exists (we'll add it to the front)
      recentlyViewed = recentlyViewed.filter(h => h !== handle);

      // Add to front of array
      recentlyViewed.unshift(handle);

      // Limit to MAX_PRODUCTS
      if (recentlyViewed.length > MAX_PRODUCTS) {
        recentlyViewed = recentlyViewed.slice(0, MAX_PRODUCTS);
      }

      // Save to localStorage
      localStorage.setItem(STORAGE_KEY, JSON.stringify(recentlyViewed));
    } catch (error) {
      console.error('Error saving recently viewed products:', error);
    }
  }

  /**
   * Clear all recently viewed products
   */
  clear() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing recently viewed products:', error);
    }
  }
}

// Initialize tracker when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new RecentlyViewedTracker();
  });
} else {
  new RecentlyViewedTracker();
}

// Export for potential use by other scripts
window.RecentlyViewedTracker = RecentlyViewedTracker;
